//官网链接
let linkPath = '';
if (window.location.hostname.includes('99api')) {
  // 正式环境
  linkPath = 'https://www.99api.com';
} else if (window.location.hostname.includes('dev122')) {
  //开发环境
  linkPath = 'http://www99.dev122.ltd';
} else if (window.location.hostname.includes('test212')) {
  //测试环境
  linkPath = 'http://www99.test212.ltd';
}

export default linkPath



// WEBPACK FOOTER //
// ./src/config/linkpath.js